import { UsuarioEffects } from './usuario.effects';

export const EffectsArray: any[] = [UsuarioEffects];